import React from "react";
import { SystemMessage } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { Accordion } from "../Accordion";
import { ExcludeProducts } from "./ExcludeProducts";

export const AdvancedSetup = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AdvancedSetup" });
  return (
    <Accordion header={t("Headline")}>
      <SystemMessage description={t("Info description")} level="alert" />

      <h3>{t("Exclude products")}</h3>
      <p>{t("Exclude products Text")}</p>
      <ExcludeProducts />
    </Accordion>
  );
};
